import { render, staticRenderFns } from "./columnLate.vue?vue&type=template&id=2d6fefa1&scoped=true&"
import script from "./columnLate.vue?vue&type=script&lang=js&"
export * from "./columnLate.vue?vue&type=script&lang=js&"
import style0 from "./columnLate.vue?vue&type=style&index=0&id=2d6fefa1&lang=scss&scoped=true&"
import style1 from "./columnLate.vue?vue&type=style&index=1&id=2d6fefa1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6fefa1",
  null
  
)

export default component.exports